import React from "react";

const nullToDefault = (value: any) =>
  value !== null &&
  value !== undefined &&
  value !== "" &&
  value !== "null" &&
  value !== "undefined"
    ? value
    : "Não informado";

const ExtractionResult = ({ result }: any) => {

  const resultAtt = typeof result === "string"
  ? JSON.parse(result)
  : result;

  const labelStyle = { fontWeight: "bold", marginRight: "4px" };
  const rowStyle: React.CSSProperties = {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "12px",
  };
  const fieldStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#333",
    letterSpacing: "0.4px",
  };

  return (
    <div
      style={{
        marginTop: "16px",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#e6fffb",
        border: "1px solid #b5f5ec",
      }}
    >

      <h3 style={{ color: "#78E01D", marginBottom: "16px" }}>Resultado da Extração</h3>

      <h4 style={{ marginBottom: "8px", borderBottom: "1px solid #78E01D" }}>Contrato</h4>
      <div style={rowStyle}>
        <div style={fieldStyle}>
          <span style={labelStyle}>Tipo:</span> {nullToDefault(resultAtt.contrato?.tipo)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Data:</span> {nullToDefault(resultAtt.contrato?.data)}
        </div>
      </div>

      <h4 style={{ marginBottom: "8px", borderBottom: "1px solid #78E01D" }}>Empresa</h4>
      <div style={rowStyle}>
        <div style={fieldStyle}>
          <span style={labelStyle}>Nome:</span> {nullToDefault(resultAtt.empresa?.nome)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>CNPJ:</span> {nullToDefault(resultAtt.empresa?.cnpj)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>NIRE:</span> {nullToDefault(resultAtt.empresa?.nire)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Endereço:</span> {nullToDefault(resultAtt.empresa?.endereco)}
        </div>
      </div>

      {resultAtt.empresa?.representante?.length > 0 && (
        <>
          <h5 style={{ marginTop: "16px", marginBottom: "8px" }}>Representantes:</h5>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            {resultAtt.empresa?.representante.map((rep: any, index: number) => (
              <div
                key={index}
                style={{
                  flex: "1 1 45%",
                  backgroundColor: "#ffffff",
                  padding: "12px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              >
                <p>
                  <strong>Nome:</strong> {nullToDefault(rep.nome)}
                </p>
                <p>
                  <strong>CPF:</strong> {nullToDefault(rep.cpf)}
                </p>
                <p>
                  <strong>Cargo:</strong> {nullToDefault(rep.cargo)}
                </p>
                <p>
                  <strong>Representante Legal:</strong>{" "}
                  {rep.representanteLegal ? "Sim" : "Não"}
                </p>
              </div>
            ))}
          </div>
        </>
      )}

      <h5 style={{ marginTop: "16px", marginBottom: "8px" }}>Capital Social:</h5>
      <div style={rowStyle}>
        <div style={fieldStyle}>
          <span style={labelStyle}>Valor:</span> {nullToDefault(resultAtt.empresa?.capitalSocial.valor)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Quotas:</span> {nullToDefault(resultAtt.empresa?.capitalSocial.quotas)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Valor da Quota:</span> {nullToDefault(resultAtt.empresa?.capitalSocial.valor_quota)}
        </div>
      </div>

      <h5 style={{ marginTop: "16px", marginBottom: "8px" }}>CNAE:</h5>
      <div style={rowStyle}>
        <div style={fieldStyle}>
          <span style={labelStyle}>Código:</span> {nullToDefault(resultAtt.empresa?.cnae.codigo)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Descrição:</span> {nullToDefault(resultAtt.empresa?.cnae.descricao)}
        </div>
      </div>

      <h4 style={{ marginTop: "24px", marginBottom: "8px", borderBottom: "1px solid #78E01D" }}>Documentos</h4>
      <div style={rowStyle}>
        <div style={fieldStyle}>
          <span style={labelStyle}>Protocolos:</span> {nullToDefault(resultAtt.documentos?.protocolos)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Certificações:</span> {nullToDefault(resultAtt.documentos?.certificacoes)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Autenticações:</span> {nullToDefault(resultAtt.documentos?.autenticacoes)}
        </div>
        <div style={fieldStyle}>
          <span style={labelStyle}>Órgão:</span> {nullToDefault(resultAtt.documentos?.orgao)}
        </div>
      </div>
    </div>
  );
};

export default ExtractionResult;
